// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui'
// import './element-variables.scss'
import 'element-ui/lib/theme-chalk/index.css'
import VueCookies from 'vue-cookies'

import VueAMap from '@vuemap/vue-amap';

import '@vuemap/vue-amap/dist/style.css'
Vue.use(VueAMap);

VueAMap.initAMapApiLoader({
  key: '82767a40c0412310cf2adc6bae92dff4',
  securityJsCode:'0e73ec87c98d204706e08f83f6a617e1',
  // 插件集合 （插件按需引入）
  plugins: ['AMap.Geocoder','AMap.Geolocation','AMap.Autocomplete', 'AMap.PlaceSearch', 'AMap.Scale', 'AMap.OverView', 'AMap.ToolBar', 'AMap.MapType',
    'AMap.PolyEditor', 'AMap.CircleEditor', 'AMap.DistrictSearch', 'AMap.CircleMarker', 'AMap.Polyline','AMap.MouseTool'
  ]
});

Vue.use(ElementUI)
Vue.use(VueCookies)

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js